export default __webpack_public_path__ + "static/media/portal.aeb6513c.png";